"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Buttons = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Buttons = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Buttons, _Component);

  var _super = _createSuper(Buttons);

  function Buttons(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Buttons);
    _this = _super.call(this, props); // eslint-disable-next-line react/state-in-constructor

    _this.state = {
      // eslint-disable-next-line react/no-unused-state
      inputInFocus: false,
      buttonLabel: props.config.buttonLabel || '',
      buttonURL: props.config.buttonURL || ''
    };
    _this.onChangeButtonLabel = _this.onChangeButtonLabel.bind((0, _assertThisInitialized2.default)(_this));
    _this.onChangeButtonURL = _this.onChangeButtonURL.bind((0, _assertThisInitialized2.default)(_this));
    _this.onChangeSend = _this.onChangeSend.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(Buttons, [{
    key: "onChangeButtonLabel",
    value: function onChangeButtonLabel(newButtonLabel) {
      this.setState({
        buttonLabel: newButtonLabel
      }, this.onChangeSend);
    }
  }, {
    key: "onChangeButtonURL",
    value: function onChangeButtonURL(newButtonURL) {
      this.setState({
        buttonURL: newButtonURL
      }, this.onChangeSend);
    }
  }, {
    key: "onChangeSend",
    value: function onChangeSend() {
      var newData = {
        buttonLabel: this.state.buttonLabel,
        buttonURL: this.state.buttonURL
      };
      this.props.onChange(newData);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var config = this.props.config;
      var buttonLabel = config.buttonLabel,
          buttonURL = config.buttonURL;
      return (0, _preact.h)("div", {
        className: "groups-widget__buttons"
      }, (0, _preact.h)(_InputGroup.default, {
        title: "Button label (optional)",
        type: "text",
        placeholder: "Show more",
        onChange: function onChange(e) {
          _this2.onChangeButtonLabel(e.target.value);
        },
        value: buttonLabel
      }), (0, _preact.h)(_InputGroup.default, {
        title: "URL (optional)",
        type: "url",
        placeholder: "https://example.com",
        onChange: function onChange(e) {
          _this2.onChangeButtonURL(e.target.value);
        },
        value: buttonURL
      }));
    }
  }]);
  return Buttons;
}(_preact.Component);

exports.Buttons = Buttons;
var _default = Buttons;
exports.default = _default;